import { cn } from '@/lib/utils';

const H1 = ({
    variant = 'default',
    color = 'black',
    className,
    ...props
}: React.HTMLAttributes<HTMLHeadingElement> & {
    variant?: 'default' | 'italic';
    color?: 'black' | 'inherit';
}) => {
    const variantClasses = {
        default:
            'lg:text-[52px] text-[32px] 2xl:text-[64px] abc inline-block leading-[120%]',
        italic: 'lg:text-[52px] text-[32px] 2xl:text-[64px] abc-italic inline-block leading-[120%] ',
    };

    const colorClasses = {
        black: 'text-black',
        inherit: 'text-inherit',
    };

    return (
        <h1
            className={cn(
                variantClasses[variant],
                colorClasses[color],
                className,
            )}
            {...props}
        />
    );
};

H1.displayName = 'H1';

export default H1;
